import { get, httpDelete, patch, post } from '../../utils/http';

export const fetchAccountPackages = ({ accountId }) => get(`/accounts/${accountId}/packages`);

export const addAccountPackage = ({ accountId, name, rules, filters, type }) =>
  post(`/accounts/${accountId}/packages`, {
    name,
    rules,
    filters,
    type
  });

export const editAccountPackage = ({ accountId, packageId, name, rules, filters, type }) =>
  patch(`/accounts/${accountId}/packages/${packageId}`, {
    name,
    rules,
    filters,
    type
  });

export const deleteAccountPackages = ({ accountId, packageId }) =>
  httpDelete(`/accounts/${accountId}/packages/${packageId}`);
